// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__Trnku","btnRed":"styles_btnRed__-mQAE","row":"styles_row__NWx0l","left":"styles_left__2GyTp","right":"styles_right__1sUHJ"};